<template>
  <container layout="main">
    <gnb />
    <full-page ref="fullPage" :options="options">
      <finbridge />
      <enterprise-value />
<!--      <pass-recommend />-->
      <pass-prime />
      <safe-guard />
<!--      safe billing eos-->
<!--      <safe-billing />-->
      <main-career />
      <main-footer />
    </full-page>
  </container>
</template>

<style lang="scss">
@import "@/styles/home";
</style>

<script>
import { createNamespacedHelpers } from "vuex";
import Vue from "vue";
import VueFullPage from "vue-fullpage.js";
import Container from "@/pages/container/index.vue";
import Gnb from "@/pages/components/layout/Gnb.vue";
import Finbridge from "@/pages/home/Finbridge.vue";
import EnterpriseValue from "@/pages/home/EnterpriseValue.vue";
// import PassRecommend from "@/pages/home/PassRecommend.vue";
import PassPrime from "@/pages/home/PassPrime.vue";
import SafeGuard from "@/pages/home/SafeGuard.vue";
// import SafeBilling from "@/pages/home/SafeBilling.vue";
import MainCareer from "@/pages/home/MainCareer.vue";
import MainFooter from "@/pages/components/layout/MainFooter.vue";
Vue.use(VueFullPage);

const { mapActions } = createNamespacedHelpers("ui");

const anchors = ["finbridge", "enterprise-value", "passprime", "safeguard", "career", "footer"];

export default {
  mixins: [],
  name: "Home",
  components: { Container, Gnb, Finbridge, EnterpriseValue, PassPrime, SafeGuard, MainCareer, MainFooter },
  props: {},
  data() {
    return {
      options: {
        licenseKey: process.env.VUE_APP_FULLPAGE_LICENSEKEY,
        menu: "#menu",
        anchors: anchors,
        navigation: true,
        navigationPosition: "right",
        responsiveWidth: 768,
        onLeave: this.onLeave,
        afterLoad: this.afterLoad,
        afterSlideLoad: this.afterSlideLoad
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions(["setSectionNumber", "setGnbType"]),
    onLeave(origin, destination, direction) {
      const $fpNav = document.querySelector("#fp-nav");
      this.setSectionNumber(0);

      if (destination.index === 0) {
        this.setGnbType("");
        $fpNav.classList.remove("grey");
      } else {
        this.setGnbType("white");
        $fpNav.classList.add("grey");
      }

    },
    afterLoad(origin, destination, direction) {
      // const { fullPage } = this.$refs;
      // let autoSlide = 0;
      this.setSectionNumber(destination.index);

      // if (destination.index == 2) {
      //   autoSlide = setInterval(() => {
      //     fullPage.api.moveSlideRight();
      //   }, 5000);
      // } else {
      //   if (autoSlide) {
      //     clearInterval(autoSlide);
      //     setTimeout(() => {
      //       autoSlide = 0;
      //     }, 5000);
      //   }
      // }
    }
  },
  created() {}
};
</script>
